// src/features/agent/components/CouponTable.tsx
import { TablePaginationConfig } from "antd";
import { Column, RecordCountBadge,Table } from "components";
import { StyledTableHeader, StyledTableWrapper } from "components/table/table.styled";
import { CouponLog} from "features/agent/types/coupon";
import { useTranslation } from "react-i18next";

export const CouponTable = ({
  couponList,
  isCouponListLoading,
  itemsCount,
  tableParams,
  updateParams,
}: any) => {
  const { t } = useTranslation(); 

  const handleTableChange = (pagination: TablePaginationConfig) => {
    updateParams({
      page: pagination.current ?? 1,
      size: pagination.pageSize ?? 10,
    });
  };
   

  return (
    <StyledTableWrapper>
      <StyledTableHeader>
        <RecordCountBadge
          text={t("CopounUser.heading.CouponTitle")}
          count={itemsCount}
        />
      </StyledTableHeader>

      <Table<CouponLog>
        rowKey="Id"
        loading={isCouponListLoading}
        dataSource={couponList}
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          pageSize: tableParams.size,
          total: itemsCount,
        }}
      >
        {/* <Column<CouponLog> title="Log ID" dataIndex="Id" />
        <Column<CouponLog> title="Coupon ID" dataIndex="CouponId" /> */}
        <Column<CouponLog> title=" Coupon Code" dataIndex="Code" />
        <Column<CouponLog> title=" Coupon Title" dataIndex="Title" />
        <Column<CouponLog> title="Action Type" dataIndex="ActionType" />
        <Column<CouponLog> title="ActionBy" dataIndex="ActionBy" />
        <Column<CouponLog> title="EventName" dataIndex="EventName" />
        <Column<CouponLog> title="ValueType" dataIndex="ValueTypeText" />
        <Column<CouponLog> title="Remaining Limit" dataIndex="RemainingApplied" />
        <Column<CouponLog>  title="Value"   dataIndex="Value" />
        <Column<CouponLog> title="StartDate" dataIndex="StartDate" />
        <Column<CouponLog> title="EndDate" dataIndex="EndDate" />
        
         

        


      </Table>
    </StyledTableWrapper>
  );
};
